














































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ProductsSelectModal from '@/web/components/products/ProductsSelectModal.vue';
import ProductCard from '@/web/components/products/ProductCard.vue';
import draggable from 'vuedraggable';
import { draggableDelay } from '@/web/utils/draggable';
import { debounce } from 'lodash';
import HMSpinner from '@/web/components/common/HMSpinner.vue';

interface LocalState {
  draggableDelay: number;
  products: ProductResponse[];
  isLoading: boolean;
}

export default Vue.extend({
  name: 'BundleIncludedProducts',
  components: { HMSpinner, ProductCard, draggable },
  data(): LocalState {
    return {
      draggableDelay,
      products: [],
      isLoading: true,
    };
  },
  async mounted() {
    this.$store.dispatch('product/getTeacherProducts');
    await this.getIncludedProducts();
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
      bundlableProducts: 'product/bundlableProducts',
    }),
    productId(): number {
      return parseInt(this.$route.params['id']);
    },
    contentExist(): boolean {
      return this.products?.length;
    },
  },
  watch: {
    query: 'getIncludedProductsDebounced',
  },
  methods: {
    async getIncludedProducts(): Promise<boolean> {
      this.isLoading = true;
      this.products = await this.$store.dispatch(
        'product/getIncludedProducts',
        this.productId
      );
      this.products.sort((a, b) => b.bundle_position - a.bundle_position);
      this.isLoading = false;
    },
    getIncludedProductsDebounced: debounce(async function (this) {
      await this.getIncludedProducts();
    }, 300),
    async reorderProducts(): Promise<void> {
      const products = this.products.map((p, index) => {
        return {
          product_id: p.id,
          position: index * -1,
        };
      });
      await this.$store.dispatch('product/reorderIncludedProducts', {
        bundleId: this.productId,
        products: products,
      });
    },
    async showAddProductsForm(): Promise<void> {
      this.$modal.show(
        ProductsSelectModal,
        {
          products: this.bundlableProducts,
        },
        { classes: ['vm--inline-modal'], clickToClose: false },
        {
          'products-selected': async (selectedProductIds: int[]) => {
            console.log('adding products: ', selectedProductIds);
            await this.$store.dispatch('product/addIncludedProducts', {
              productId: this.productId,
              data: {
                products: selectedProductIds,
              },
            });
            await this.getIncludedProducts();
          },
        }
      );
    },
    async removeIncludedProduct(id): Promise<void> {
      await this.$store.dispatch('product/deleteIncludedProduct', {
        bundleId: this.productId,
        productId: id,
      });
      await this.getIncludedProducts();
    },
  },
});
